import { toast } from 'react-toastify';

// Components
import { Toast } from '@repo/zolintra-ui';

const useToast = () => {
  /**
   * Trigger a call to react-toastify with a custom Toast component
   *
   * @param {Object} params
   * @param {string} params.message
   * @param {('success'|'alert'|'info')} [params.type='success']
   * @param {boolean} [params.hasIcon=false]
   * @param {boolean} [params.hasCross=false]
   * @param {number} [params.autoClose=5000]
   * @param {Object} [params.options={}] - react-toastify options
   */
  const notify = ({
    message, type = 'success', hasIcon = false, hasCross = false, autoClose = 5000, options = {},
  }) => {
    toast(
      <Toast
        type={type}
        hasIcon={hasIcon}
        hasCross={hasCross}
      >
        {message}
      </Toast>,
      {
        autoClose,
        ...options,
      },
    );
  };

  return {
    notify,
  };
};

export default useToast;
